export default {
  publicCloudfrontURL: 'https://d17jmxltsx3ffm.cloudfront.net',
  businessName: 'DeuteRx',
  sanityURL: 'https://izvq1fr7.apicdn.sanity.io/v1/graphql/production/default',
  emailURL: 'https://aiikn63n03.execute-api.us-east-1.amazonaws.com/prod/email/send',
  emailAddress: 'info@deuterx.com',
};
